<template>
  <div class="some_random_class">
    <h3 v-if="title" class="my-2 is-size-4">{{ title }}</h3>
    <div v-for="block in breakdown_json" :class="generate_class(block.term)">
      <div class="block-term">
        <span>
          {{ filterTerm(block.term) }}
        </span>
      </div>
      <div class="block-detail">
        <span>
          {{ filterDetail(block) }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["breakdown", "title"],
  methods: {
    generate_class(value) {
      let class_name = "single-block";

      if (value == "line") {
        class_name += " has-half-line";
      }
      if (value == "full-line") {
        class_name += " has-full-line";
      }
      return class_name;
    },
    filterTerm(value) {
      switch (value) {
        case "line":
        case "full-line":
          return "";
        default:
          return value;
      }
    },
    filterDetail(block) {
      var text = this.filterTerm(block.detail);
      if (block.text_type == "price") {
        text = "৳" + this.numberWithCommas(text);
      }
      return text;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  computed: {
    breakdown_json() {
      return JSON.parse(this.breakdown);
    },
  },
};
</script>
<style lang="scss">
.single-block {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
  background: rgba(242, 242, 242, 0.5);
  padding: 3px;
  &.has-half-line,
  &.has-full-line {
    background: transparent;
  }
  .block-term {
    font-weight: bold;
  }
  .block-detail {
    min-width: 100px;
    text-align: right;
  }
  &.has-half-line {
    .block-detail {
      border-bottom: 1px solid #333;
    }
  }
  &.has-full-line {
    border-bottom: 1px solid #333;
  }
}
</style>
